import Rails from "rails-ujs";

import "components/activeadmin/activeadmin";
// import "components/activeadmin/cocoon";
import "components/activeadmin/extras";
// import "components/plupload";

Rails.start();
